export function formatFieldValue(value) {
  if (value == null || String(value).trim() === '') return '(empty)';
  return String(value);
}

export function formatRecordPairs(pairs = []) {
  if (!pairs.length) return '(no fields)';
  return pairs.map(({ key, value }) => `${key}: ${formatFieldValue(value)}`).join(', ');
}

export function buildRowSnapshots(row) {
  const before = { ...(row.current_raw || {}) };
  const after = row.is_new
    ? { ...(row.proposed_raw || {}) }
    : { ...before };
  const modifications = [];

  for (const change of row.field_changes || []) {
    if (change.included === false) continue;
    if (change.new_value === undefined) continue;
    modifications.push(change);
    after[change.key] = change.new_value;
  }

  return { before, after, modifications };
}

export function previewHasActionableRows(preview) {
  return (preview?.planes || []).some((plane) => (
    (plane.rows || []).some((row) => {
      if (row.included === false) return false;
      return (row.field_changes || []).some((c) => c.included !== false && c.new_value !== undefined);
    })
  ));
}

export function formatModificationLine(change) {
  const key = change.key;
  const oldVal = formatFieldValue(change.old_value);
  const newVal = formatFieldValue(change.new_value);
  return `${key} was ${oldVal} before, and was changed to: ${newVal}.`;
}

export function formatIngestSuccessBlock(record) {
  const lines = [];
  lines.push(`**${record.group_name || record.group_slug}** — ${record.label || 'Record'}`);
  lines.push(`Here is the record. ${formatRecordPairs(record.after)}`);
  if (record.field_modifications?.length) {
    lines.push('Here are the fields we modified:');
    for (const mod of record.field_modifications) {
      lines.push(formatModificationLine(mod));
    }
  }
  return lines.join('\n');
}
